// src/components/SummaryCards.jsx — Long/Short 노출·손익 요약
import React from "react";
import { portfolioExposure } from "../lib/exposure";

function fmtKRW(n) {
  if (n == null || isNaN(n)) return "—";
  const sign = n < 0 ? "-" : "";
  return sign + "₩" + Math.round(Math.abs(n)).toLocaleString("ko-KR");
}
function pct(n) {
  if (n == null || isNaN(n)) return "—";
  return `${n >= 0 ? "+" : ""}${n.toFixed(1)}%`;
}

export default function SummaryCards({ holdings, marketData, exchangeRates, nav }) {
  const e = portfolioExposure(holdings, marketData, exchangeRates);
  const base = nav > 0 ? nav : e.longKRW || 1; // NAV 미입력 시 롱노출로 대체
  const p = (v) => (v / base) * 100;

  const cards = [
    { label: "순노출 Net", value: fmtKRW(e.netKRW), sub: `${pct(p(e.netKRW))} of NAV`, color: "#1a1a2e" },
    { label: "그로스 Gross", value: fmtKRW(e.grossKRW), sub: `${p(e.grossKRW).toFixed(0)}% of NAV`, color: "#4a90d9" },
    { label: "롱 노출", value: fmtKRW(e.longKRW), sub: `${p(e.longKRW).toFixed(0)}%`, color: "#0a7c59" },
    { label: "숏 노출", value: fmtKRW(e.shortKRW), sub: `${p(e.shortKRW).toFixed(0)}%`, color: "#c0392b" },
    { label: "총 손익", value: `${e.pnlKRW >= 0 ? "+" : ""}${fmtKRW(e.pnlKRW)}`, sub: "롱+숏 합산", color: e.pnlKRW >= 0 ? "#0a7c59" : "#c0392b" },
    { label: "당일 손익", value: `${e.todayPnlKRW >= 0 ? "+" : ""}${fmtKRW(e.todayPnlKRW)}`, sub: "오늘", color: e.todayPnlKRW >= 0 ? "#0a7c59" : "#c0392b" },
  ];

  return (
    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))", gap: 12, marginBottom: 24 }}>
      {cards.map((card) => (
        <div key={card.label} style={{
          background: "#fff", border: "1px solid #e8e8e8", borderRadius: 12,
          padding: "16px 20px", borderTop: `3px solid ${card.color}`,
        }}>
          <div style={{ fontSize: 11, color: "#888", marginBottom: 6, letterSpacing: "0.05em", textTransform: "uppercase" }}>{card.label}</div>
          <div style={{ fontSize: 20, fontWeight: 700, color: card.color, lineHeight: 1.2 }}>{card.value}</div>
          <div style={{ fontSize: 12, color: "#aaa", marginTop: 4 }}>{card.sub}</div>
        </div>
      ))}
    </div>
  );
}
